export const environment = {
  production: true,
  urlMapping: {
    PROJ_API: 'https://kavach.vassardigital.ai/kavach/api/services',
    PROJ_API_URL: 'https://kavach.vassardigital.ai/kavach/api',
    SSE_URL: 'https://kavach.vassardigital.ai/api/sse/conversations',

    // PROJ_API: 'https://kavach.vassardigital.ai/api/kavach/services',
    USERMGMT_API: "https://kavach.vassardigital.ai/um/",
    //  WEBSOCKET_URL:"wss://qa.ce.vassardigital.ai/ws/chatbot/",
    DOMAIN_URL: "https://kavach.vassardigital.ai/",
    EXTRACTION_API: 'https://kavach.vassardigital.ai/kavach/api/extraction',
  },
  KEYCLOAK_URLS: {
    BASE_URL: 'https://kavach.vassardigital.ai/auth',
    REDIRECT_URL: 'https://kavach.vassardigital.ai/landing',
    LOGOUT_URL: 'https://kavach.vassardigital.ai/login'
  },
  YOLO_CALLBACK_URL: "https://kavach.vassardigital.ai/kavach/api/services/yolo_callback",
  CLIENT_ID: 'kavachusermgmt',
  REALM_NAME: 'KavachUM'

};
